module.exports = __webpack_public_path__ + "media/images/athletes/1759-673b8e3969ee1710a4040fe66e6c69ca.png";